import { action, makeObservable, observable } from 'mobx';
import { Injectable } from './service.base';
import { IAlertDialog } from '~/views/types';

@Injectable()
export class AlertDialogService {
    @observable public open = false;
    @observable public headerText: string;
    @observable public mainText: string;
    @observable public showContactInfo = true;

    constructor() {
        makeObservable(this);
    }

    @action
    handleOpen = () => {
        this.open = true;
    };

    @action
    handleClose = () => {
        this.open = false;
    };

    @action
    setData = (data: IAlertDialog) => {
        this.headerText = data.headerText ? data.headerText : '';
        this.mainText = data.mainText ? data.mainText : '';
        this.showContactInfo = data.showContactInfo ? data.showContactInfo : false;
    };
}
